<template>
  <div class="row">
    <div class="col-md-12">
      <div class="widget fluid">
        <div class="whead">
          <h6>Basic Info</h6>
        </div>
        <div class="card-body card-block">
          <form
            action
            method="post"
            enctype="multipart/form-data"
            class="form-horizontal"
            v-on:submit.prevent="save()"
          >
            <div class="row form-group">
              <div class="col col-md-3">
                <label for="password" class="form-control-label" v-required>Password</label>
              </div>
              <div class="col-12 col-md-9">
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder
                  class="form-control"
                  v-model="input.password"
                  ref="password"
                >
              </div>
            </div>
            <div class="row form-group">
              <div class="col col-md-3">
                <label
                  for="password_confirmation"
                  class="form-control-label"
                  v-required
                >Confirm Password</label>
              </div>
              <div class="col-12 col-md-9">
                <input
                  type="password"
                  id="password_confirmation"
                  name="password_confirmation"
                  placeholder
                  class="form-control"
                  v-model="input.password_confirmation"
                  ref="password_confirmation"
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageSettings: {
        pageTitle: 'Change Password',
        sectionName: 'changepassword',
        navigation: [
          { name: 'Change Password' },
        ],
        buttons: [
          { name: 'Save', icon: 'fas fa-save', action: this.save }
        ],
        subSidebar: {
          buttons: [
            
          ]
        }
      },
      input: {
        password: null,
        password_confirmation: null,
      },
      modelID: this.$route.params.id ? this.$route.params.id : null,
      processing: false,
      errorObj: {
        status: false,
        message: null
      },
      timer: null
    }
  },
  created() {

    if (this.modelID)
      this.getData()

  },
  mounted() {
    this.$emit('setPageHeader', this.pageSettings)
  },
  computed: {
    isDisabled() {
      return this.input.password == null || this.input.password_confirmation == null || this.processing
    },
  },
  methods: {
    getData() {
      this.$http
        .get(this.WebService.user + '/' + this.$route.params.id)
        .then((response) => {
          this.input = response.data.data
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(null)
    },
    save() {
      this.update()
    },
    update() {

      if (this.input.password == null) {
        this.$refs.password.focus()
        return false
      }

      if (this.input.password_confirmation == null) {
        this.$refs.password_confirmation.focus()
        return false
      }

      if (this.input.password != this.input.password_confirmation) {
        this.$emit('alertBox', { content: 'The password and confirmation password do not match.' })
        return false
      }

      // Process
      this.processing = true
      this.$http
        .put(this.WebService.changePassword, this.input)
        .then((response) => {

          console.log(response)

          this.input.password = null
          this.input.password_confirmation = null

          this.$emit('alertBar', {
            type: 'success',
            title: 'Success',
            content: 'Password update successfully.',
          })
        })
        .catch((err) => {

          this.$emit('alertBar', {
            type: 'danger',
            title: 'Failed',
            content: err.data.errors,
          })

        })
        .finally(this.processing = false)

    },
  }
}
</script>